import React, { Fragment } from 'react'
import Icon from './../../Icon/Icon'
import Tooltip from 'rc-tooltip'
import './styles.css'

export default ({
  label,
  secondaryLabel,
  required,
  className,
  labelStyle,
  showTitle,
  helpText,
  helpTextTools: {
    icon,
    iconSize,
    iconColor,
    tooltipColor,
    tooltipBackgroundColor
  } = {}
}) => {
  if (!label) return null
  return (
    <div className={`field-label`} title={(showTitle && label && label.toUpperCase()) || ``}>
      <label className={className} style={labelStyle}>
        {label}
        {secondaryLabel &&
          <Fragment>
            <br />
            {secondaryLabel}
          </Fragment>
        }
        <abbr>
          {required ? '*' : ''}
        </abbr>
        <style jsx>
          {`
            label {
              color: #999;
              font-weight: normal;
              opacity: 0.75;
              padding-left: 2px;
              pointer-events: none;
              text-transform: capitalize;
              font-size: 0.75rem;
              color: var(--labelColor);

              abbr {
                color: var(--requiredLabelColor, red);
              }
            }
            .custom-control-label {
                position: absolute;
            }
          `}
        </style>
      </label>
      {
        helpText && helpText.length &&
          <>
            <Tooltip
              overlay={<div dangerouslySetInnerHTML={{ __html: helpText }} />}
              overlayStyle={{zIndex: 10000}}
              placement={'top'}
            >
              <span>
                <Icon
                  icon={icon ?? 'help'}
                  iconSize={iconSize}
                  styling={{ iconColor }}
                  style={{
                    verticalAlign: 'middle',
                    fontSize: iconSize
                  }}
                />
              </span>
            </Tooltip>
            <style jsx>
              {`
                :global(.rc-tooltip) {
                  z-index: 2450;
                }
                :global(.rc-tooltip-placement-top .rc-tooltip-arrow) {
                  border-top-color: ${tooltipBackgroundColor || ''};
                }
                :global(.rc-tooltip-inner) {
                  background-color: ${tooltipBackgroundColor || ''};
                  color: ${tooltipColor || ''};
                  max-width: 300px;
                }
                :global(.rc-tooltip-inner div hr) {
                  border-top: 1px solid ${tooltipColor || '#fff'};
                  margin-top: .5rem;
                  margin-bottom: .5rem;
                  opacity: .5;
                }
                :global(.rc-tooltip-inner div p) {
                  margin-bottom: .5rem;
                }
                :global(.rc-tooltip-inner div p:last-child) {
                  margin-bottom: 0;
                }
              `}
            </style>
          </>
      }
    </div>
  )
}
